// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.VerifiedBadge__verified-c18a5b {
  fill: none;
  margin-inline-start: 6px;
  min-width: 16px;
}`, "",{"version":3,"sources":["webpack://./src/components/VerifiedBadge/VerifiedBadge.styles.m.css"],"names":[],"mappings":"AAAA;EACE,UAAA;EACA,wBAAA;EACA,eAAA;AACF","sourcesContent":[".verified {\n  fill: none;\n  margin-inline-start: 6px;\n  min-width: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"verified": `VerifiedBadge__verified-c18a5b`
};
module.exports = ___CSS_LOADER_EXPORT___;
